import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent  {

  constructor() { 
    console.log('minidashboard constructor')
  }


}
